var gulpBuild = 1792829326604;"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.assign(window, function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      get: function get(that, keys) {
        var node = that;
        keys.split('.').map(function (key, i, keys) {
          node = _typeof(node) == 'object' ? node[key] : node;
        });
        return node;
      },
      set: function set(that, keys, value) {
        var node = that;
        keys.split('.').map(function (key, i, keys) {
          node = node[key] = i == keys.length - 1 ? value : node[key] || {};
        });
        return that;
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    // objects
    π: {
      // methods
      add: function add(keys, code) {
        if (code) {
          PRIV.set(π, keys, PRIV.get(π, keys) || {});
          Object.assign(PRIV.get(π, keys), code);
        }
      }
    }
  };
}());;"use strict";

π.add('head.scripts', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      loadScript: function loadScript(script, callback) {
        var scriptTag = document.createElement('script');
        scriptTag.addEventListener('load', function () {
          if (this['src'].includes('onload=')) {
            var method = {};
            method[this['src'].split('onload=')[1].split('&')[0]] = {};
            PRIV.apply(method);
          }
          callback();
        });
        setTimeout(function () {
          if (script['src']) {
            if (!script['src'].includes('?')) {
              var timestamp = PRIV.getPreloadTime(script) || (PRIV.isLocal() ? Date.now() : ''),
                query = timestamp != '' ? '?' + timestamp : '';
              scriptTag['src'] = script['src'] + query;
            } else {
              scriptTag['src'] = script['src'];
            }
          } else if (script['code']) {
            scriptTag['text'] = script['code'];
            callback();
          }
          if (_vars['lastScriptTag']) {
            _vars['lastScriptTag'].after(scriptTag);
          } else {
            document.body.appendChild(scriptTag);
          }
          _vars['lastScriptTag'] = scriptTag;
        }, script['delay'] || 0);
      },
      loadStack: function loadStack(stack) {
        if (Array.isArray(stack) && stack['length']) {
          PRIV.loadScript(stack.shift(), function () {
            if (stack['length']) {
              PRIV.loadStack(stack);
            } else {
              document.body.classList.add('js-loaded');
            }
          });
        }
      },
      loadQueue: function loadQueue(queue) {
        if (Array.isArray(queue)) {
          queue.forEach(PRIV.loadStack);
        }
      },
      apply: function apply(method) {
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var key = Object.keys(method)[0],
          args = method[key]['args'],
          thisArg = method[key]['thisArg'];
        if (π && π.helpers && π.helpers.utils.applyMethod && typeof gv == 'function') {
          π.helpers.utils.applyMethod(window, method, args, thisArg);
        } else if (i < 100) {
          setTimeout(function () {
            return PRIV.apply(method, ++i);
          }, 100);
        }
      },
      isLocal: function isLocal() {
        return location['host'].includes('localhost') || location['host'].match(new RegExp('^[1-9]{1,3}\.')) !== null;
      },
      getPreloadTime: function getPreloadTime(that) {
        if (that['id']) {
          var preload = document.getElementById(that['id']);
          return preload ? preload['href'].split('?')[1] : undefined;
        } else {
          return undefined;
        }
      }
    },
    _refs = {},
    _vars = {
      queue: [],
      lastScriptTag: undefined
    };

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {},
    load: function load(stack) {
      if (Array.isArray(stack)) {
        PRIV.loadStack(stack);
      }
    },
    queue: function queue(stack) {
      if (Array.isArray(stack)) {
        _vars['queue'].push(stack);
      }
    },
    onImagesLoaded: function onImagesLoaded() {
      PRIV.loadQueue(_vars['queue']);
    }
  };
}());;"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
π.add('head.styles', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      isLocal: function isLocal() {
        return location['host'].includes('localhost') || location['host'].match(new RegExp('^[1-9]{1,3}\.')) !== null;
      },
      isSlowNetwork: function isSlowNetwork() {
        return 'connection' in navigator && ['slow-2g', '2g', '3g'].includes(navigator['connection']['effectiveType']);
      },
      getPreloadTime: function getPreloadTime(name) {
        var preloadLink = document.getElementById('preload-' + name + '-css');
        return preloadLink ? preloadLink['href'].split('?')[1] : '';
      },
      onLoad: function onLoad() {
        var _this = this;
        _vars['hrefs'] = _vars['hrefs'].filter(function (href) {
          return !_this.href.endsWith(href);
        });
        if (!_vars['hrefs']['length']) {
          setTimeout(function () {
            document.getElementsByTagName('html')[0]['classList'].remove('no-css');
            document.body.classList.add('css-loaded');
          }, 10);
        }
      }
    },
    _refs = {},
    _vars = {
      hrefs: []
    };

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    load: function load() {
      var styles = Array.isArray(arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 0 ? undefined : arguments[0] : [arguments.length <= 0 ? undefined : arguments[0]],
        head = document.getElementsByTagName('head')[0];
      styles.forEach(function (style) {
        var name = _typeof(style) == 'object' ? Object.keys(style)[0] : style,
          path = _typeof(style) == 'object' ? style[name] : style,
          link = document.createElement('link'),
          time = PRIV.getPreloadTime(name),
          query = time ? '?' + time : '',
          href = !path.includes('?') ? path + query : path;
        link.addEventListener('load', PRIV.onLoad);
        link['rel'] = 'stylesheet';
        link['href'] = href;
        _vars['hrefs'].push(href);
        head.appendChild(link);
      });
      if (PRIV.isSlowNetwork()) {
        document.getElementsByTagName('html')[0]['classList'].remove('no-css');
      }
    }
  };
}());;"use strict";

π.add('app.head.worker', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      register: function register() {
        navigator.serviceWorker.getRegistration().then(function (registration) {
          if (!registration) {
            navigator.serviceWorker.register('/sw.js').then(function (registration) {
              // console.info('service worker has been registered');
              PRIV.update(registration);
            })["catch"](console.error);
          } else {
            // console.info('service worker has already been registered');
            PRIV.update(registration);
          }
        });
      },
      unregister: function unregister(callback) {
        navigator.serviceWorker.getRegistration().then(function (registration) {
          if (registration) {
            registration.unregister().then(function (success) {
              if (success) {
                console.info('service worker has been unregistered');
              } else {
                console.error('service worker could not be unregistered');
              }
              PRIV.deleteBrowserCache(callback);
            })["catch"](console.error);
          } else {
            // console.info('no service worker was registered');
            π.helpers.utils.applyMethod(callback);
          }
        });
      },
      update: function update(registration) {
        if (_.isObject(navigator, 'serviceWorker.controller')) {
          registration.update().then(function (registration) {
            // console.info('service worker has been updated');
          })["catch"](console.error);
        } else {
          console.info('service worker is available but not controlling the page');
        }
      },
      deleteBrowserCache: function deleteBrowserCache(callback) {
        if ('caches' in window) {
          caches.keys().then(function (cacheNames) {
            return Promise.all(cacheNames.map(function (cacheName) {
              return caches["delete"](cacheName);
            }));
          }).then(function () {
            console.info('browser cache has been delete');
            π.helpers.utils.applyMethod(callback);
          })["catch"](console.error);
        } else {
          π.helpers.utils.applyMethod(callback);
        }
      },
      isAvailable: function isAvailable() {
        return _.isObject(navigator, 'serviceWorker') && π.server.getProtocol() == 'https';
      },
      isRefused: function isRefused() {
        return π.main.refs.html.hasClass('refuse-service-worker') || π.main.refs.body.hasClass('refuse-service-worker');
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      if (PRIV.isAvailable()) {
        if (PRIV.isRefused()) {
          PRIV.unregister();
        } else {
          PRIV.register();
        }
      }
    },
    unregister: function unregister(callback) {
      if (PRIV.isAvailable()) {
        PRIV.unregister(callback);
      } else {
        π.helpers.utils.applyMethod(callback);
      }
    }
  };
}());
//# sourceMappingURL=head.js.map
